import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { sanitizeFilters } from "@/helpers/request-helpers";
import { IServiceInterface } from "@/interfaces/service-interface.interface";
import serviceInterfaceService from "@/services/service-interface.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export interface Props extends RequestPagination {
  filters: IFilter<IServiceInterface>[];
}

type GetAllSwrParams = [string, number, number, IFilter<IServiceInterface>[]];

export type Return = RequestsBaseReturn<PaginatedResponse<IServiceInterface> | null>;

const useGetServiceInterfaces = ({ pageNumber, pageSize, filters }: Props): Return => {
  const activeFilters = sanitizeFilters(filters);
  const fetcher = useSWR<PaginatedResponse<IServiceInterface>, Error, GetAllSwrParams>(
    [SWR_KEYS.getServiceInterfaces, pageNumber, pageSize, activeFilters],
    ([, _pageNumber, _pageSize, _filters]) => {
      if (_filters.length > 0) {
        return serviceInterfaceService.filter(_filters, {
          pageNumber: _pageNumber,
          pageSize: _pageSize,
        });
      }
      return serviceInterfaceService.getAll({ pageNumber: _pageNumber, pageSize: _pageSize });
    },
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetServiceInterfaces;
